function AuthMw (request, next) {
  next(function (response) {
    if (response.status === 500 && (response.body.name === 'forbidden' || response.body.name === 'event_not_found')) {
      this.$session.set('role', '')
      this.$session.set('logged', false)
      this.$router.push({name: 'Login'})
    }
  })
}

export default AuthMw
